import { Button } from './Button'

export const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}: {
  totalItems: number
  itemsPerPage: number
  currentPage: number
  onPageChange: (page: number) => void
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const isFirstPage = currentPage === 1
  const isLastPage = currentPage === totalPages

  const startItem = (currentPage - 1) * itemsPerPage + 1
  const endItem = Math.min(currentPage * itemsPerPage, totalItems)

  return (
    <nav
      className="flex w-full items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
      aria-label="Pagination"
    >
      {endItem !== 0 && (
        <div className="hidden sm:block">
          <p className="text-xs text-gray-700">
            Showing <span className="font-medium">{startItem}</span> to{' '}
            <span className="font-medium">{endItem}</span> of{' '}
            <span className="font-medium">{totalItems}</span> results
          </p>
        </div>
      )}
      {totalPages > 1 && (
        <div className="flex flex-1 justify-between gap-2 sm:justify-end">
          <Button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={isFirstPage}
          >
            Previous
          </Button>
          <Button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={isLastPage}
          >
            Next
          </Button>
        </div>
      )}
    </nav>
  )
}
